import { Component } from "react";

/**
 * Catches failed lazy-chunk loads (e.g. flaky network) so the app never shows
 * a permanent blank screen. Notifies the parent to surface a Retry action.
 */
export default class ChunkErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(err) {
    if (this.props.onError) this.props.onError(err);
  }

  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}
